import { render, staticRenderFns } from "./MarketSearchResultsRow.vue?vue&type=template&id=061bb480&"
import script from "./MarketSearchResultsRow.vue?vue&type=script&lang=js&"
export * from "./MarketSearchResultsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports